import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ɵConsole } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
@Component({
  selector: 'app-purchasereport',
  templateUrl: './purchasereport.component.html',
  styleUrls: ['./purchasereport.component.css']
})
export class PurchasereportComponent implements OnInit, AfterViewInit, OnDestroy {


  purchasereportColl: any = [];

  partyColl: any = [];


  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;

  istableloading: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Purchase";

  filterpartyid: number = null;
  filterfromdate: any = new Date();
  filtertodate: any = new Date();
  filtersearchtxt: any = "";

  filterColl:any[]=[]

  groupby:any='DETAILS'

  searchtxt: any = "";
  columnDefs = [
    { headerName: 'Purchase No', field: 'purchaseno' },
    { headerName: 'Date', field: 'purchasedate', type: 'date' },
    { headerName: 'Supplier', field: 'partyname' },
    { headerName: 'PaymentMode', field: 'paymentmodename' },
    { headerName: 'Invoice No', field: 'refno' },
    { headerName: 'Description', field: 'descr' },
    { headerName: 'Grand Total', field: 'grandtotal',type: 'decimal' },
  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  };


  columnDefs1 = [
    { headerName: 'Purchase No', field: 'purchaseno' },
    { headerName: 'Date', field: 'purchasedate', type: 'date' },
    { headerName: 'Rawmaterial', field: 'rawmaterialname' },    
    { headerName: 'Group', field: 'itemcategoryname' },
    { headerName: 'Unit', field: 'uomname' },    
    { headerName: 'Qty', field: 'qty' ,type: 'decimal' },
    { headerName: 'UnitPrice', field: 'unitprice' ,type: 'decimal' },    
    { headerName: 'SubTotal', field: 'subtotal' ,type: 'decimal' },
    { headerName: 'Discount', field: 'discamt' ,type: 'decimal' },    
    { headerName: 'Amount Before Taxable', field: 'taxable',type: 'decimal'  },
    { headerName: 'Tax', field: 'taxname',type: 'decimal'  },
    { headerName: 'TaxRate', field: 'taxrate',type: 'decimal'  },
    { headerName: 'CGST%', field: 'cgsttaxrate',type: 'decimal'  },
    { headerName: 'CGSTAmount', field: 'cgsttaxamt',type: 'decimal'  },
    { headerName: 'SGST%', field: 'sgsttaxrate',type: 'decimal'  },
    { headerName: 'SGSTAmount', field: 'sgsttaxamt',type: 'decimal'  },    
    { headerName: 'Net Total', field: 'nettotal',type: 'decimal' },
  ]

  gridOptions1 = {
    enableactioncol: false,
    columnDefs: this.columnDefs1,
  };

 
  columnDefs2= [   
    { headerName: 'Rawmaterial', field: 'rawmaterialname' },    
    { headerName: 'Group', field: 'itemcategoryname' },
    { headerName: 'Unit', field: 'uomname' },    
    { headerName: 'Qty', field: 'qty' ,type: 'decimal' },
    { headerName: 'UnitPrice', field: 'unitprice' ,type: 'decimal' },    
    { headerName: 'SubTotal', field: 'subtotal' ,type: 'decimal' },
    { headerName: 'Discount', field: 'discamt' ,type: 'decimal' },    
    { headerName: 'Amount Before Taxable', field: 'taxable',type: 'decimal'  },
    { headerName: 'Tax', field: 'taxname',type: 'decimal'  },
    { headerName: 'TaxRate', field: 'taxrate',type: 'decimal'  },
    { headerName: 'CGST%', field: 'cgsttaxrate',type: 'decimal'  },
    { headerName: 'CGSTAmount', field: 'cgsttaxamt',type: 'decimal'  },
    { headerName: 'SGST%', field: 'sgsttaxrate',type: 'decimal'  },
    { headerName: 'SGSTAmount', field: 'sgsttaxamt',type: 'decimal'  },    
    { headerName: 'Net Total', field: 'nettotal',type: 'decimal' },
  ]

  gridOptions2 = {
    enableactioncol: false,
    columnDefs: this.columnDefs2,
  };


  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal, private route: ActivatedRoute, private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, public loginService: LoginDataService) {
    this.fnGetParameterVariable();
    this.fnServiceChanges();

    this.filterfromdate.setDate(this.filterfromdate.getDate() - 15);
  }

  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.partyid !== undefined) {
        this.filterpartyid = params.partyid
      }
    })
  }
  //User Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }
    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
         
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {

    this.fngetParty();

    this.fnGetFilterStatus()
  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  ngAfterViewInit(): void {
  
  }

  ngOnDestroy(): void {
  
  }

  fnGetFilterStatus() {
    this.filterColl = []
    this.filterColl.push({ value: 'DETAILS', displayname: 'Details' });
    this.filterColl.push({ value: 'SUMMARY', displayname: 'Summary' });
    this.filterColl.push({ value: 'PRODUCTWISE', displayname: 'ProductWise' });
    
  }




  fngetParty() {
    var data = {
      'partyid': 0,
      'ptype': 'S',
      'companyid': this.loginService.fnGetCompanyId()       

    }
    this.appService.getParty(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.partyColl = res.json().result;
          
            this.fngetPurchaseReport();
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetPurchaseReport() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'purchaseid': 0,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
      'partyid': this.filterpartyid,
      'companyid': this.loginService.fnGetCompanyId(),     
      'groupby': this.groupby,
    }
    this.appService.getPurchaseReport(data)
      .subscribe(
        (res) => {

          this.fnHideProgress();
          if (res.json().status == 200) {
            this.purchasereportColl = res.json().result;

            this.fnSetDataTable();
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }


  fnCurrentRouteChange() {
    var queryParams = {};



    if (this.filterpartyid > 0) {
      queryParams['partyid'] = this.filterpartyid;
    }



    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,

      });
  }


  private fnSetDataTable() {
  
  }


  fnPrintData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnExportData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCloseForm() {
    try {
      this.router.navigate(['/Report']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

 
  fnGetDescription(id) {
    const index = this.purchasereportColl.findIndex(sku => sku.purchaseid === id);

    if (index) {
      return this.purchasereportColl[index].taxgroupname;
    }
    else {
      return "";
    }

  }
  public fnSearchDatatable(value) {

  

  }
  //AddPurchase
  fnActionExportClick() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs =this.groupby=='SUMMARY'?this.columnDefs:this.groupby=='DETAILS'?this.columnDefs1:this.columnDefs2;
    modalRef.componentInstance.contentColl = this.purchasereportColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    
    });

  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()       

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{

        });

    } catch {

    }
  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//hh:mm a  
    }
    else {
      return '';
    }
  }

  fnMomentDateTimeFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY hh:mm a');//  
    }
    else {
      return '';
    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
